import { configureStore } from '@reduxjs/toolkit';
import caseClusterReducer from '@/store/slices/caseCluster';
import clientsReducer from '@/store/slices/clients';
import meetingReducer from '@/store/slices/meeting';

export const store = configureStore({
  reducer: {
    meeting: meetingReducer,
    caseCluster: caseClusterReducer,
    clients: clientsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
